/* eslint-disable prettier/prettier */
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const commonStyles = css`
  font-size: 20px;
  line-height: 20px;
  user-select: none;
  padding: 10px 8px 8px;
  white-space: nowrap;
  border-radius: 4px;
`;

const styles = {
  primary: {
    background: '#48A5DD',
    color: 'white',
    border: 'none',
    '&:hover': {
      background: '#3C89B7',
    },
  },
  secondary: {
    background: 'white',
    color: '#6C6C6C',
    border: '1px solid #999999',
    '&:hover': {
      background: '#e6e6e6',
    },
  },
};

interface Props {
  type?: 'primary' | 'secondary';
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  children?: string;
  sx?: React.CSSProperties;
  id?: string;
}

const Button = ({
  type = 'primary',
  onClick,
  disabled = false,
  children,
  sx,
  id = '',
}: Props) => {
  const handleClick = () => {
    if (onClick) onClick();
  };
  return (
    <button
      id={id}
      onClick={handleClick}
      css={[
        commonStyles,
        styles[type],
        { ...(sx ? sx : {}) },
        { ...(disabled ? { pointerEvents: 'none', opacity: 0.7 } : {}) },
      ]}
    >
      {children}
    </button>
  );
};

export default Button;
